import { ThunkAction } from 'redux-thunk';
import { IStoreState } from 'src/store';
import { Action } from '@reduxjs/toolkit';

// Generic thunk type matching FrameworkThunk pattern
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  IStoreState,
  unknown,
  Action<string>
>;

// Event handler types
export type ReactMouseHandler = (event: React.MouseEvent<HTMLElement, MouseEvent>) => void;
export type ReactKeyboardHandler = (event: React.KeyboardEvent<HTMLElement>) => void;
export type ReactChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => void;
export type ReactFormHandler = (event: React.FormEvent<HTMLFormElement>) => void;

// Event type for EventHelper (string ID or React/DOM event)
// Using Element instead of HTMLElement for broader compatibility
export type EventOrElement =
  | React.SyntheticEvent
  | React.MouseEvent
  | React.KeyboardEvent
  | Event
  | EventTarget
  | string;

// Type guard utilities
export function isAxiosError(error: any): error is import('axios').AxiosError {
    return error?.isAxiosError === true;
}
